var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 19",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 9.5c0 4.964 4.037 9 9 9 4.962 0 9-4.036 9-9 0-4.963-4.038-9-9-9-4.963 0-9 4.037-9 9m1.524 0c0-4.122 3.353-7.475 7.476-7.475s7.475 3.354 7.476 7.475c0 4.124-3.354 7.476-7.476 7.476-4.123 0-7.476-3.352-7.476-7.476",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.031 7.804h1.937v6.787H8.031zM9 6.872A1.23 1.23 0 1 0 9 4.41a1.23 1.23 0 0 0 0 2.462"
  })));
};
export default SvgInfo;